import { OnInit, OnChanges, Component, SimpleChanges, inject } from "@angular/core";
import { EntityBase } from "../../_models/EntityBase";
import { IGenericComponent } from "../_primitives/IGeneriComponent";
import { EntityConstructor } from "../../services/DependecyInjection.provider";
import { IEntityMetaData } from "../../_models/IEntityMetaData";
import { IStaticStylesConfig } from "../../skins/_primitives/IStaticStylesConfig";
import { Subscription } from "rxjs";
import { TranslationService } from "../../services/TranslationService";
import { MatwinsVariablesService } from "../../services/matwinsVariables.service";
@Component({
  template: '', // fourni par les enfants
  standalone: true
})
export abstract class GenericComponent<T extends EntityBase> implements IGenericComponent<T>, OnInit, OnChanges {
  isLoading = false;
  currentLanguage = 'en';
  private langSubscription: Subscription = new Subscription();
  private static componentDiscriminentId = 0;
  abstract Editable: boolean;

  public abstract ComponentEntityClass: EntityConstructor<T>;
  public abstract entityMetaData: IEntityMetaData;
  public abstract Skin: IStaticStylesConfig;

  Initiator: IGenericComponent<T> | null | undefined;


  protected ComponentName = this.constructor.name;
  protected componentId: string;

  protected readonly matwinsVariablesService: MatwinsVariablesService = inject(MatwinsVariablesService);
  //protected readonly notificationHub = inject(NotificationHubService);
  //private notificationSubscription: Subscription = new Subscription();


  // Gestion des permissions : Accesseurs a overrider imperativement !
  public abstract get RequiredPermissions(): string[];
  public abstract get HasRequiredPermissions(): boolean;


  //public translationService = inject(TranslationService)

  constructor() {
    GenericComponent.componentDiscriminentId++;
    this.ComponentName += `_${GenericComponent.componentDiscriminentId}`;
    const componentName = this.ComponentName;
    let id = this.matwinsVariablesService.setDictionnaryId(componentName);
    this.componentId = id;
    //console.log(this.componentId);
    //console.log(this.ComponentName);

  }

  public static getTranslationService(): TranslationService {
    if (!TranslationService.instance) {
      // Fallback – attendre ou logger une erreur
      console.warn('TranslationService non initialisé, utilisation de la clé brute');
      throw new Error('TranslationService not ready');
    }
    return TranslationService.instance;
  }

  getComponentId(): string {
    return this.componentId;
  }
  onDataRefreshNeeded() {
    //  console.log(this.notificationHub.entitiesToRefresh);
  }

  // ---------- lifecycle ----------
  ngOnInit(): void {
    // S'abonner aux changements de langue
    this.langSubscription = GenericComponent.getTranslationService().currentLanguage$.subscribe(lang => {
      this.currentLanguage = lang;
    });
  }

  ngOnDestroy() {
    this.langSubscription.unsubscribe();
    // this.notificationSubscription.unsubscribe();
  }


  ngAfterViewInit(): void {

  }
  ngOnChanges(changes: SimpleChanges): void { }


  public static FormatDate(date: Date, format: string, defaultTimeFormat: string | null = null): string {
    // Recuperation du format 12-24h
    if (defaultTimeFormat?.toLowerCase().trim() == '12h' && !format.toLocaleLowerCase().trim().endsWith(' tt')) {
      format = `${format.trim()} tt`;                                // on rajoute le tt
      format = format.replace(" H ", " h ").replace(" HH ", " hh "); // on force les heures  
    }
    else if (defaultTimeFormat?.toLowerCase().trim() == '24h' && format.toLocaleLowerCase().trim().endsWith(' tt')) {
      format = `${format.trim()}###`.replace('tt###', '').replace('###', ''); // on supprime le tt
      format = format.replace(" h ", " H ").replace(" hh ", " HH ");          // on force les heures 
    }

    const map: Record<string, string> = {
      'yyyy': date.getFullYear().toString(),
      'yy': date.getFullYear().toString().slice(-2),
      'MM': String(date.getMonth() + 1).padStart(2, '0'),
      'M': String(date.getMonth() + 1),
      'dd': String(date.getDate()).padStart(2, '0'),
      'd': String(date.getDate()),
      'HH': String(date.getHours()).padStart(2, '0'),
      'H': String(date.getHours()),
      'hh': String(date.getHours() % 12 || 12).padStart(2, '0'),
      'h': String(date.getHours() % 12 || 12),
      'mm': String(date.getMinutes()).padStart(2, '0'),
      'm': String(date.getMinutes()),
      'ss': String(date.getSeconds()).padStart(2, '0'),
      's': String(date.getSeconds()),
      'fff': String(date.getMilliseconds()).padStart(3, '0'),
      'tt': date.getHours() >= 12 ? 'PM' : 'AM'
    };

    return format.replace(/yyyy|yy|MM|M|dd|d|HH|H|hh|h|mm|m|ss|s|fff|tt/g,
      matched => map[matched] || matched
    );
  }


  public static GetFormatedDateValue(value: Date | string | null | undefined, localDateTimeFormat: string, defaultTimeFormat: string | null | undefined) {
    if (value instanceof Date) {
      return GenericComponent.FormatDate(value, localDateTimeFormat);

    } else if (value) {
      const newDate = new Date(value as string);
      return GenericComponent.FormatDate(newDate, localDateTimeFormat);
    } else {
      return '';
    }

  }
  public static GetFormatedDateTimeValue(value: Date | string | null | undefined, localDateTimeFormat: string, defaultTimeFormat: string | null | undefined) {
    if (value instanceof Date) {
      return GenericComponent.FormatDate(value, localDateTimeFormat, defaultTimeFormat);

    } else if (value) {
      const newDate = new Date(value as string);
      return GenericComponent.FormatDate(newDate, localDateTimeFormat, defaultTimeFormat);
    } else {
      return '';
    }

  }
}

